import { MAP_SIZE, TILE_SIZE } from './worldConstants';

export interface WorldLayout {
  tileWidth: number;
  tileHeight: number;
}

export interface WorldPixelSize {
  width: number;
  height: number;
}

export const DEFAULT_WORLD_LAYOUT: WorldLayout = {
  tileWidth: MAP_SIZE,
  tileHeight: MAP_SIZE,
};

export const DEFAULT_CAMERA_ZOOM = 1;
export const MAX_WORLD_TILE_COORDINATE = 999;
export const MAX_WORLD_TILE_SIZE = MAX_WORLD_TILE_COORDINATE + 1;

const clampTileCount = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }
  return Math.max(1, Math.min(MAX_WORLD_TILE_SIZE, Math.floor(parsed)));
};

export const normalizeWorldLayout = (value: unknown): WorldLayout => {
  if (!value || typeof value !== 'object') {
    return { ...DEFAULT_WORLD_LAYOUT };
  }

  const candidate = value as Partial<WorldLayout>;
  return {
    tileWidth: clampTileCount(candidate.tileWidth, DEFAULT_WORLD_LAYOUT.tileWidth),
    tileHeight: clampTileCount(candidate.tileHeight, DEFAULT_WORLD_LAYOUT.tileHeight),
  };
};

export const normalizeCameraZoom = (value: unknown): number => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return DEFAULT_CAMERA_ZOOM;
  }
  return Math.max(0.25, Math.min(4, parsed));
};

export const getWorldPixelSize = (layout: WorldLayout): WorldPixelSize => ({
  width: layout.tileWidth * TILE_SIZE,
  height: layout.tileHeight * TILE_SIZE,
});

export const clampTileX = (value: number, layout: WorldLayout): number =>
  Math.max(0, Math.min(layout.tileWidth - 1, Math.floor(value)));

export const clampTileY = (value: number, layout: WorldLayout): number =>
  Math.max(0, Math.min(layout.tileHeight - 1, Math.floor(value)));

export const clampTilePoint = (
  point: { x: number; y: number },
  layout: WorldLayout,
): { x: number; y: number } => ({
  x: clampTileX(point.x, layout),
  y: clampTileY(point.y, layout),
});
